import { render, staticRenderFns } from "./publicProp.vue?vue&type=template&id=0bb097b9&scoped=true&"
import script from "./publicProp.vue?vue&type=script&lang=ts&"
export * from "./publicProp.vue?vue&type=script&lang=ts&"
import style0 from "./publicProp.vue?vue&type=style&index=0&id=0bb097b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb097b9",
  null
  
)

export default component.exports